/**
 * KAN-721: флажок материала оператора с подписью и подсказкой ("Можно
 * отправлять в переписке", "Прикладывать к письму", "Основной прайс-лист").
 * Нативный checkbox с label: одна роль checkbox, клик по подписи переключает.
 */

interface MaterialFlagCheckboxProps {
  id: string;
  label: string;
  hint: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  /** Доступное имя (подпись + название материала в строке списка). */
  ariaLabel?: string;
}

export function MaterialFlagCheckbox({
  id,
  label,
  hint,
  checked,
  onChange,
  ariaLabel,
}: MaterialFlagCheckboxProps): JSX.Element {
  const hintId = `${id}-hint`;
  return (
    <div className="flex items-start gap-2">
      <input
        id={id}
        type="checkbox"
        className="mt-0.5 h-4 w-4 flex-shrink-0 cursor-pointer"
        checked={checked}
        aria-label={ariaLabel}
        aria-describedby={hintId}
        onChange={e => onChange(e.target.checked)}
      />
      <div className="text-xs leading-tight">
        <label htmlFor={id} className="cursor-pointer font-medium">
          {label}
        </label>
        <p id={hintId} className="text-muted-foreground">
          {hint}
        </p>
      </div>
    </div>
  );
}
